import {
	useHistory,
	useLocation,
	useRouteMatch,
	useParams,
} from "react-router";
import { common_utils } from "../../../../../../common/common_utils";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { BackButton } from "../base_components/back_button";
import { DashboardContainer } from "../base_components/dashboard_container";
import { CSVDownload } from "../csv_download";
import { usePreviousPage } from "../hooks/use_prev_page";
import { RSVPList } from "./rsvp_list";
import { stringify } from "csv-stringify/lib/index";
import { useEffect } from "react";
import { setDocTitle } from "../../../web_ui";
import { useDocTitle } from "../hooks/use_doc_title";

export function RSVPDisplayFormPage() {
	const history = useHistory();

	const prev_page = usePreviousPage();

	let { server_id, message_id } = useParams<{
		server_id: string;
		message_id: string;
	}>();

	const csv_download_mutation = trpc.event.rsvpedUsersCsv.useMutation({
		onSuccess: (data) => {
			stringify(data, (err, output) => {
				if (err) {
					DashboardUtils.ShowDefaultErrorAlert(err.toString());
					return;
				}

				const element = document.createElement("a");

				const file = new Blob([output], { type: "text/plain" });
				element.href = URL.createObjectURL(file);
				element.download = `attendee_data_${message_id}.csv`;
				document.body.appendChild(element); // Required for this to work in FireFox
				element.click();
			});
		},
	});

	const event_query = trpc.event.getListItem.useQuery(
		{
			guild_id: server_id,
			message_id,
		},
		{
			staleTime: Infinity,
		}
	);

	useDocTitle(
		event_query.data?.name ? `${event_query.data.name} RSVPers` : `RSVPs`
	);

	if (event_query.isError) {
		return (
			<DashboardUtils.RenderDashboardErrorPage
				title="Error 404"
				text={`Event ${message_id} not found.`}
			/>
		);
	}

	if (!event_query.isSuccess) {
		return DashboardUtils.RenderFullLoadingThrobberPage();
	}

	const has_event_ended =
		new Date(event_query.data.end_time_str) < new Date();

	return (
		<DashboardContainer
			title={
				<>
					<i>{DashboardUtils.LimitName(event_query.data.name, 16)}</i>{" "}
					RSVPs
				</>
			}
			bread_crumbs={
				<BackButton
					label={prev_page?.label ?? "Back"}
					onClick={() => {
						history.push(
							prev_page?.url ??
								common_utils.getEventListURL(server_id)
						);
					}}
				/>
			}
		>
			<div className="flex flex-col gap-4">
				<div className="ml-auto">
					<CSVDownload
						onClick={() =>
							csv_download_mutation.mutate({
								guild_id: server_id,
								message_id,
							})
						}
						is_loading={csv_download_mutation.isLoading}
					/>
				</div>
				<div className="flex flex-col gap-8">
					{event_query.data.rsvp_options.map((val) => (
						<RSVPList
							key={val.id}
							option={val}
							has_event_ended={has_event_ended}
						/>
					))}
				</div>
			</div>
		</DashboardContainer>
	);
}
